import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch",
  id: "#kt_header_menu",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item me-lg-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Ana Sayfa", -1)
const _hoisted_4 = { class: "menu-item me-lg-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Veritabanı Listesi", -1)
const _hoisted_6 = { class: "menu-item me-lg-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Şirket Listesi", -1)
const _hoisted_8 = { class: "menu-item me-lg-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Restoran Listesi", -1)
const _hoisted_10 = { class: "menu-item me-lg-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Restoran Istatistiği", -1)
const _hoisted_12 = { class: "menu-item me-lg-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Şirket İstatistiği", -1)
const _hoisted_14 = { class: "menu-item me-lg-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Ödemeler", -1)
const _hoisted_16 = { class: "menu-item me-lg-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Ayarlar", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Drawer = _resolveComponent("Drawer")!

  return (_openBlock(), _createBlock(_component_Drawer, {
    class: "header-menu align-items-stretch",
    id: "kt_header_menu",
    name: "header-menu",
    activate: "{default: true, lg: false}",
    toggleButton: '#kt_header_menu_mobile_toggle',
    "data-kt-swapper": "true",
    "data-kt-swapper-mode": "prepend",
    "data-kt-swapper-parent": "{default: '#kt_body', lg: '#kt_header_nav'}"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            class: "menu-link",
            to: "/dashboard",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "menu-link",
            to: "/database",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            class: "menu-link",
            to: "/company",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            class: "menu-link",
            to: "/restourant",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            class: "menu-link",
            to: "/istatistik",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_router_link, {
            class: "menu-link",
            to: "/istatistik_company",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_router_link, {
            class: "menu-link",
            to: "/income",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_router_link, {
            class: "menu-link",
            to: "/settings",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}